import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.scss';

import Login from './Pages/Login/Login';
import SSOLogin from './Pages/Login/SSOLogin';
import AppVideo from './Pages/AppVideo';
import Logout from './components/Logout';
import CleverLogin from './Pages/Login/CleverLogin';
import ResetPassword from './Pages/Login/ResetPassword';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import PublicRoute from './Routes/PublicRoute';
import PrivateRoute from './Routes/PrivateRoute';
import CourseInvoiceView from './Modules/User/CEU_Cources/course_Payment/CourseInvoiceView';

// start public route
const Home = React.lazy(() => import('./Pages/Home'));
const About = React.lazy(() => import('./Pages/About'));
const CEU = React.lazy(() => import('./Pages/CEU'));
const FigLifestyle = React.lazy(() => import('./Pages/FigLifestyle'));
const Coaches = React.lazy(() => import('./Pages/Coaches'));
const ContactUs = React.lazy(() => import('./Pages/ContactUs'));
const RequestCard = React.lazy(() => import('./Pages/ContactUs/RequestCard'));
const WebinarCard = React.lazy(() => import('./Pages/ContactUs/WebinarCard'));
const RequestSchoolCard = React.lazy(() => import('./Pages/ContactUs/RequestSchoolCard'));
const MeetTeam = React.lazy(() => import('./Pages/MeetTeam'));
// end public route

// start private route
const CEUCources = React.lazy(() => import('./Modules/User/CEU_Cources'));
const AuthorProfile = React.lazy(() => import('./Modules/User/CEU_Cources/AuthorProfile'));
const CourseCardDetail = React.lazy(() => import('./Modules/User/CEU_Cources/Course_Card_Detail'));
const Community = React.lazy(() => import('./Modules/User/Community'));
const CommunityGroups = React.lazy(() => import('./Modules/User/CommunityGroups'));
const ComGroupDetail = React.lazy(() => import('./Modules/User/CommunityGroups/ComGroupDetail'));
const AllCertificateDash = React.lazy(() => import('./Modules/User/Dashboard/AllCertificate'));
const Dashboard = React.lazy(() => import('./Modules/User/Dashboard/Index'));
const NotificationList = React.lazy(() => import('./Shared/Notification/NotificationList'));
const FigLifeStyle = React.lazy(() => import('./Modules/User/FigLifeStyle'));
const Messages = React.lazy(() => import('./Modules/User/Messages'));
const Profile = React.lazy(() => import('./Modules/User/Profile'));
const Recipe = React.lazy(() => import('./Modules/User/Recipe'));
const RecipeDeatail = React.lazy(() => import('./Modules/User/Recipe/RecipeDetail'));
const Reports = React.lazy(() => import('./Modules/User/Reports'));
const Setting = React.lazy(() => import('./Modules/User/Settings/Setting'));
const Certificate = React.lazy(() => import('./Modules/User/Certificate/User_Report'));
const CertificateUserNew = React.lazy(() => import('./Modules/User/Certificate_New/index'));
const SepratePageTableData = React.lazy(() => import('./Modules/User/Dashboard/SepratePage_TableData'));
const ResetPasswordLogged = React.lazy(() => import('./Modules/User/ResetPasswordLogged'));
const CompleteCource = React.lazy(() => import('./Modules/User/CEU_Cources/completeCourse'));
const EmailPreference = React.lazy(() => import('./Modules/User/Email_Preference'));
const ViewProfile = React.lazy(() => import('./Modules/User/ViewProfile'));
const Privacy = React.lazy(() => import('./Modules/User/Privacy'));
const FigFamily = React.lazy(() => import('./Modules/User/FigFamily'));
const ViewQuizSubmitted = React.lazy(() => import('./Modules/User/Reports/QuizSubmittedList/ViewQuizSubmitted'));
const FigFamilyProfile = React.lazy(() => import('./Modules/User/FigFamily/FigFamilyProfile'));
const Help = React.lazy(() => import('./Modules/User/Help'));
const CourseDetail = React.lazy(() => import('./Pages/CEU/CourseDetail'));
const MainFreeSources = React.lazy(() => import('./Pages/MainFreeSources'));
const PreferredPartners = React.lazy(() => import('./Modules/User/Preferred_Partners'));
const NewCommunity = React.lazy(() => import('./Modules/User/New_Community'));
const CommunityDetails = React.lazy(() => import('./Modules/User/New_Community/CommunityDetails'));
const SuccessCourse = React.lazy(() => import('./Modules/User/CEU_Cources/SuccessCourse'));
const FreeSources = React.lazy(() => import('./Modules/User/FreeSources'));
const FreeSourceDetail = React.lazy(() => import('./Modules/User/FreeSources/FreeSourceDetail'));
const MainFreeSourceDetail = React.lazy(() => import('./Pages/MainFreeSources/MainFreeSourceDetail'));
const Goal = React.lazy(() => import('./Modules/User/Goal'));
const PaymentSuccess = React.lazy(() => import('./Pages/PaymentSuccess'));
const EmployeeReviewList = React.lazy(() => import('./Modules/User/EmployeeReview/EmployeeReviewList'));
const NewDashboard = React.lazy(() => import('./Modules/User/NewDashboard'));
const EvalutionDashboard = React.lazy(() => import('./Modules/User/Dashboard/Evalution/EvalutionDashboard'));
const MainPerferredPartner = React.lazy(() => import('./Pages/MainPerferredPartner'));
const MainFigFamilyProfile = React.lazy(() => import('./Modules/User/FigFamily/FigFamilyProfile/MainFigFamilyProfile'));
const StartCource = React.lazy(() => import('./Modules/User/CEU_Cources/StartCource'));
const CoursePayment = React.lazy(() => import('./Modules/User/CEU_Cources/course_Payment/CoursePayment'));
const ReceiptPage = React.lazy(() => import('./Modules/User/CEU_Cources/course_Payment/ReceiptPage'));
const TemplateView = React.lazy(() => import('./Modules/User/Dashboard/TemplateViewAll/index.jsx'));
// end private route


function App() {

  return (
    <>
      {/* <Suspense fallback={<div className="loader">
          <CircularProgress sx={{ color: "#86c65a" }} />
        </div>}> */}
      <Router>
        <Logout />
        <Routes>
          {/* Without Login pages start */}
          <Route element={<PublicRoute />}>
            <Route path='/' element={<Home />} />
            <Route path='/home' element={<Home />} />
            <Route path='/about' element={<About />} />
            <Route path='/ceu' element={<CEU />} />
            <Route path='/ceu/:id' element={<CourseDetail />} />
            <Route path='/figlifestyle' element={<FigLifestyle />} />
            <Route path='/figlifestyle/:id' element={<CourseDetail />} />
            <Route path='/coaches' element={<Coaches />} />
            <Route path='/contactus' element={<ContactUs />} />
            <Route path='/contactus/requestcard' element={<RequestCard />} />
            <Route path='/contactus/webinarcard' element={<WebinarCard />} />
            <Route path='/contactus/requestschoolcard' element={<RequestSchoolCard />} />
            <Route path='/meet-team' element={<MeetTeam />} />
            <Route path='/free' element={<MainFreeSources />} />
            <Route path='/free/:id' element={<MainFreeSourceDetail />} />
            <Route path='/preferred' >
              <Route index element={<MainPerferredPartner />} />
              <Route path=':id' element={<MainFigFamilyProfile />} />
            </Route>
          </Route>
          {/* Without Login pages end */}

          {/* <Route path='/' element={<Login />} /> */}
          <Route path='/app-video' element={<AppVideo />} />
          <Route path='/login' element={<Login />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/privacy' element={<PrivacyPolicy />} />
          <Route path='/clever-login' element={<CleverLogin />} />
          <Route path='/sso-login' element={<SSOLogin />} />
          {/* }} element={<Navigate to="/sso-login/code" />} /> */}
          <Route path='/sso-login/code' element={<SSOLogin />} />
          <Route path='/resetpassword/:email' element={<ResetPassword />} />
          <Route element={<PrivateRoute />}>
            <Route path='/dashboard'  >
              <Route index element={<NewDashboard />} />
              {/* <Route path='new' element={<PrivateRoute><NewDashboard /></PrivateRoute>} /> */}
              <Route path='old' element={<Dashboard />} />
              <Route path='notifications' element={<NotificationList />} />
              <Route path='coursePurchase/:id' element={<CoursePayment />} />
              <Route path='all-certificate' element={<AllCertificateDash />} />
              <Route path='course-schedule' element={<SepratePageTableData />} />
              <Route path='course-name' element={<SepratePageTableData />} />
              <Route path='top-student' element={<SepratePageTableData />} />
              <Route path='completed-course-roster/:id?/:status?' element={<SepratePageTableData />} />
              <Route path='evalution' element={<EvalutionDashboard />} />
              <Route path='employee-review' element={<EmployeeReviewList />} />
              {/* <Route path='employee-review/:id' element={<PrivateRoute><EmployeeReview /></PrivateRoute>} /> */}
            </Route>
            <Route path='/settings' element={<Setting />} />
            <Route path='/settings/courseSetting/:id' element={<Setting />} />
            <Route path='/settings/evaluation/:id' element={<Setting />} />
            <Route path='/settings/generalSetting/:id' element={<Setting />} />
            <Route path='/settings/hrSetting/:id' element={<Setting />} />
            <Route path='/settings/mainSiteSetting/:id' element={<Setting />} />
            <Route path='/settings/recipeSetting/:id' element={<Setting />} />
            <Route path='/settings/schoolSetting/:id' element={<Setting />} />
            <Route path='/settings/figCommunication/:id' element={<Setting />} />
            <Route path='/settings/:id' element={<Setting />} />
            <Route path='/edit-profile' element={<Profile />} />
            <Route path='/edit-profile/:id' element={<Profile />} />
            <Route path='/logged-reset-password' element={<ResetPasswordLogged />} />
            <Route path='/ceu-courses'>
              <Route index element={<CEUCources />} />
              {/* <Route path='/ceu-courses/:key?' element={<PrivateRoute><CEUCources /> </PrivateRoute>} /> */}
              <Route path='/ceu-courses/:id' element={<CourseCardDetail />} />
              <Route path='/ceu-courses/start-course/:id' element={<StartCource />} />
              <Route path='/ceu-courses/complete-course/:id' element={<CompleteCource />} />
              <Route path='/ceu-courses/success-course/:id' element={<SuccessCourse />} />
              <Route path='/ceu-courses/author/:id' element={<AuthorProfile />} />
              <Route path='/ceu-courses/coursePurchase/:id' element={<CoursePayment />} />
              <Route path='/ceu-courses/receipt' element={<ReceiptPage />} />
              <Route path='/ceu-courses/courseInvoiceView/:id' element={<CourseInvoiceView />} />
            </Route>
            <Route path='/recipe' element={<Recipe />} />
            <Route path='/recipe/:id' element={<RecipeDeatail />} />
            <Route path='/fig-lifestyle'>
              <Route index element={<FigLifeStyle />} />
              <Route path='/fig-lifestyle/:id' element={<CourseCardDetail />} />
              <Route path='/fig-lifestyle/start-course/:id' element={<StartCource />} />
              <Route path='/fig-lifestyle/complete-course/:id' element={<CompleteCource />} />
              <Route path='/fig-lifestyle/success-course/:id' element={<SuccessCourse />} />
              <Route path='/fig-lifestyle/author/:id' element={<AuthorProfile />} />
              <Route path='/fig-lifestyle/coursePurchase/:id' element={<CoursePayment />} />

            </Route>
            <Route path='/reports' element={<Reports />} />
            <Route path='/reports/quizReport/:id' element={<Reports />} />
            <Route path='/reports/reportMenu/:id/:courseId?' element={<Reports />} />
            <Route path='/reports/superAdminReport/:id' element={<Reports />} />
            <Route path='/reports/userReport/:id' element={<Reports />} />
            <Route path='/reports/templateView/:editId' element={<TemplateView />} />
            <Route path='/community-old' element={<Community />} />
            <Route path='/community' element={<NewCommunity />} />
            <Route path='/community/:id' element={<CommunityDetails />} />
            <Route path='/messages' element={<Messages />} />
            <Route path='/messages/:chatId' element={<Messages />} />
            <Route path='/community-groups' element={<CommunityGroups />} />
            <Route path='/community-groups/:id' element={<ComGroupDetail />} />
            <Route path='/certificate/report/:id' element={<Certificate />} />
            {/* <Route path='/certificate/:id' element={<PrivateRoute><CertificateUserNew /> </PrivateRoute>} /> */}
            <Route path='/certificate/:courseid/:userid/:ayid/:certificateId' element={<CertificateUserNew />} />
            <Route path='/view-profile/:id' element={<ViewProfile />} />
            <Route path='/email-preference' element={<EmailPreference />} />
            <Route path='/privacy' element={<Privacy />} />
            <Route path='/fig-family' element={<FigFamily />} />
            <Route path='/fig-family/:id' element={<FigFamilyProfile />} />
            <Route path='/view-quiz-submitted/:courseid/:userid/:ayid' element={<ViewQuizSubmitted />} />
            <Route path='/help' element={<Help />} />
            {/* <Route path='/training' element={<PrivateRoute><Training /> </PrivateRoute>} /> */}
            <Route path='/preferred-partners' element={<PreferredPartners />} />
            <Route path='/preferred-partners/:id' element={<FigFamilyProfile />} />
            <Route path='/preferred-partners/user/:id' element={<ViewProfile />} />
            <Route path='/free-sources' element={<FreeSources />} />
            <Route path='/free-sources/:id' element={<FreeSourceDetail />} />
            <Route path='/goal' element={<Goal />} />
            <Route path='/complete-payment/:id/:amt' element={<PaymentSuccess />} />

            <Route path='*' element={<Dashboard />} />
          </Route>
        </Routes>
      </Router>
      {/* </Suspense> */}
    </>
  );
}

export default React.memo(App);
